import { render, staticRenderFns } from "./SubUserCreate.vue?vue&type=template&id=352036c0"
import script from "./SubUserCreate.vue?vue&type=script&lang=js"
export * from "./SubUserCreate.vue?vue&type=script&lang=js"
import style0 from "./SubUserCreate.vue?vue&type=style&index=0&id=352036c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports